import { api } from "@/components/provider";
import type { Word } from "@kys/shared-types";

export const favoritesApi = {
  list: (page = 0) => api<Word[]>(`favorites?page=${page}`),
  contains: async (wordId: string) => (await api<Word[]>(`favorites?word_id=${encodeURIComponent(wordId)}`)).some(word => word.id === wordId),
  set: (wordId: string, saved: boolean) => api<{ ok: boolean }>("favorites", { word_id: wordId, saved }),
};
